export enum CountrySortType {
    CODE,
	NAME
}